<script setup lang="ts">
import { useChatStore } from '../stores/chatStore';

const props = withDefaults(defineProps<{ isOpen: boolean }>(), {
  isOpen: true,
});

const chatStore = useChatStore();

// モーダル閉じる
const emit = defineEmits(['closeModalEvent']);
const closeModal = () => {
  emit('closeModalEvent')
}
</script>

<template>
  <div v-if="props.isOpen"
    class="inset-0 flex flex-col items-center justify-center pt-4 aichat-bg z-40 overflow-hidden h-full">

    <div class="outline outline-1 flex-1 outline-design-gray w-[90%] overflow-y-scroll bg-white p-8"
      v-html="chatStore.uiTextAttention">
    </div>

    <div class="mt-8 mb-8">
      <button type="button" @click="closeModal"
        class="w-[230px] h-[80px] rounded-md bg-design-red text-sm text-white px-5" v-html="$t('startBtn')">
      </button>
    </div>
  </div>
</template>

<style scoped>
::-webkit-scrollbar {
  /* スクロールバー全体の幅 */
  width: 13px;

  /* スクロールバーの背景色 */
  background-color: none
}

::-webkit-scrollbar-thumb {
  /* スクロールバーの丸み */
  border-radius: 10px;

  /* スクロールバーの色 */
  box-shadow: inset 0 0 10px 10px #C3C3C3;

  /* スクロールバーの左右の余白 */
  border: solid 4px transparent;
}

.text-sm {
  font-size: .875rem;
}

.text-center {
  text-align: center;
}

.font-bold {
  font-weight: 700;
}

.mt-10 {
  margin-top: 2.5rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.leading-6 {
  line-height: 1.5rem;
}
</style>